import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel'; // requires a loader
import React, { ReactNode } from 'react';

type Props = {
    images?: any[];
    onCompleteSlide: (idx: number, item: ReactNode) => void;
};
export default function MRomComsCarousel({ images, onCompleteSlide }: Props) {
    return (
        <React.Fragment>
            {images && images.length > 0 && (
                <Carousel
                    showThumbs={false}
                    onChange={onCompleteSlide}
                    infiniteLoop
                    autoPlay={false}
                    showIndicators={false}
                >
                    {images?.map((f, i) => {
                        return (
                            <div key={i}>
                                <img src={f.url} alt="image" />
                            </div>
                        );
                    })}
                </Carousel>
            )}
        </React.Fragment>
    );
}
